/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { institutionsSearch } from "../../funcs/institutionsSearch.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListInstitutionsRequest$inboundSchema,
};

export const tool$institutionsSearch: ToolDefinition<typeof args> = {
  name: "institutions-search",
  description:
    `This endpoint has been deprecated and will be removed in a future release. Use [/institutions](https://docs.moov.io/api/enrichment/form-shortening/institutions/get/).

Search for institutions by either their name or routing number.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/fed.read\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await institutionsSearch(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
